import { render, staticRenderFns } from "./PalletTable.vue?vue&type=template&id=476ac4cf&"
import script from "./PalletTable.vue?vue&type=script&lang=js&"
export * from "./PalletTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476ac4cf')) {
      api.createRecord('476ac4cf', component.options)
    } else {
      api.reload('476ac4cf', component.options)
    }
    module.hot.accept("./PalletTable.vue?vue&type=template&id=476ac4cf&", function () {
      api.rerender('476ac4cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/pallet/PalletTable.vue"
export default component.exports